(() => {
  'use strict';
  const storageKey = 'crc-pen-quote-v1:' + (window.Shopify?.theme?.id || 'theme');
  const scope = () => document.querySelector('[data-crc-product-handle="metal-pens"]');
  const clean = (value, limit = 8000) => String(value || '').replace(/\u0000/g, '').slice(0, limit);
  const withPreview = url => {
    const preview = new URLSearchParams(location.search).get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    else if (window.Shopify?.theme?.role !== 'main' && window.Shopify?.theme?.id) {
      url.searchParams.set('preview_theme_id', String(window.Shopify.theme.id));
    }
    return url;
  };
  const quoteUrl = data => {
    const url = new URL((window.Shopify?.routes?.root || '/') + 'pages/contact', location.origin);
    url.search = new URLSearchParams({
      view:'pen-quote', project:'bulk', product:'Custom Metal Pens', source:'product',
      quantity:String(data.quantity), customization:data.customization || 'Text / Name'
    });
    return withPreview(url);
  };
  const persist = data => {
    const id = Date.now().toString(36) + Math.random().toString(36).slice(2,8);
    try {
      sessionStorage.setItem(storageKey, JSON.stringify({...data,id,savedAt:Date.now()}));
      return id;
    } catch { return ''; }
  };
  const formContext = () => {
    const product = scope();
    const form = product?.querySelector('.js-product-form');
    if (!form) return null;
    const properties = {};
    for (const [name,value] of new FormData(form)) {
      if (name.startsWith('properties[') && typeof value === 'string') {
        const key = name.slice(11,-1);
        if (!key.startsWith('_')) properties[clean(key,100)] = clean(value);
      }
    }
    const groups = Array.from(product.querySelectorAll('variant-picker .option-selector'));
    const customization = groups.find(group => /customization|engraving/i.test(group.textContent))?.querySelector('input:checked,select')?.value;
    const quantity = Number(product.querySelector('variant-picker input:checked')?.value) || 1;
    return {quantity,customization:customization || 'Text / Name',properties,variantId:form.querySelector('[name="id"]')?.value || ''};
  };
  const prepareLink = (link, quantity, save = false) => {
    const data = formContext();
    if (!data) return new URL(link.href);
    data.quantity = quantity || (link.hasAttribute('data-crc-pen-bulk') ? Math.max(25,data.quantity) : data.quantity);
    const url = quoteUrl(data);
    if (save || quantity) {
      const id = persist(data);
      if (id) url.searchParams.set('pen_context',id);
    } else {
      const previous = new URL(link.href).searchParams.get('pen_context');
      if (previous) url.searchParams.set('pen_context',previous);
    }
    link.href = url.href;
    return url;
  };
  const fromItem = (item,quantity) => {
    const data = {quantity,customization:item.options_with_values?.[1]?.value || 'Text / Name',properties:item.properties || {},variantId:String(item.variant_id || '')};
    const url = quoteUrl(data);
    const id = persist(data);
    if (id) url.searchParams.set('pen_context',id);
    return url;
  };
  window.CRCPenQuote = {prepareLink,fromItem};
  const penLink = link => {
    if (!scope() || !link) return false;
    const url = new URL(link.href);
    return url.origin === location.origin && /\/pages\/contact$/.test(url.pathname) &&
      (link.hasAttribute('data-crc-quote-link') || link.hasAttribute('data-crc-pen-bulk') || url.searchParams.get('product') === 'Custom Metal Pens');
  };
  document.addEventListener('click',event => {
    const link = event.target.closest('a[href]');
    if (penLink(link)) prepareLink(link,undefined,true);
  },true);
  const syncLinks = () => {
    if (!scope()) return;
    document.querySelectorAll('a[href]').forEach(link => {
      if (penLink(link)) prepareLink(link);
    });
    const error = scope().querySelector('[data-crc-pen-upload-fallback]');
    if (error && scope().querySelector('[data-ph-fieldname="Logo or photo upload"]')) error.hidden = true;
  };
  document.addEventListener('on:variant:change',syncLinks);
  syncLinks();

  const section = document.querySelector('[data-crc-pen-quote]');
  if (!section) return;
  const form = section.querySelector('form');
  if (!form) return;
  if (section.dataset.crcPreview === 'true') form.addEventListener('submit',event => event.preventDefault(),true);
  if (section.querySelector('[data-pen-success]')) {
    try { sessionStorage.removeItem(storageKey); } catch {}
    return;
  }
  if (section.querySelector('[data-pen-server-errors]')) return;
  const params = new URLSearchParams(location.search);
  const field = key => form.querySelector('[data-pen-field="' + key + '"]');
  const set = (key,value) => { const input = field(key); if (input && value) input.value = clean(value); };
  const requestedQuantity = params.get('quantity') || '';
  if (/^[1-9]\d{0,5}$/.test(requestedQuantity)) set('quantity',String(Math.min(100000,Number(requestedQuantity))));
  const styles = ['Text / Name','Business Logo','Logo + Text'];
  if (styles.includes(params.get('customization'))) set('customization',params.get('customization'));
  let data = null;
  try { data = JSON.parse(sessionStorage.getItem(storageKey) || 'null'); } catch {}
  const valid = data && data.id === params.get('pen_context') && Date.now() - data.savedAt < 3600000 && Date.now() >= data.savedAt;
  const back = withPreview(new URL(section.querySelector('[data-crc-pen-back]').href));
  if (valid) {
    const properties = data.properties || {};
    set('text',properties['Engraving Text'] || properties['Engraving text']);
    set('notes',properties['Design Notes'] || properties['Design notes']);
    const proof = properties['Proof Requested'] || properties['Proof requested'];
    if (proof === 'No proof needed') set('proof',proof);
    else if (proof) set('proof','Please send a proof before engraving');
    const uploads = Object.entries(properties).filter(([key,value]) => !key.startsWith('_') && /logo|photo|artwork|upload/i.test(key) && typeof value === 'string' && value.trim());
    if (uploads.length) {
      const raw = uploads.map(([key,value]) => clean(key,100) + ': ' + clean(value)).join('\n');
      set('uploads',raw);
      section.querySelector('[data-pen-uploads]').hidden = false;
      const list = section.querySelector('[data-pen-upload-list]');
      const urls = [...new Set(raw.match(/https?:\/\/[^\s"'<>\\\]}]+/g) || [])];
      for (const candidate of urls.slice(0,10)) {
        try {
          const url = new URL(candidate);
          if (!['https:','http:'].includes(url.protocol)) continue;
          const li = document.createElement('li');
          const link = document.createElement('a');
          link.href = url.href;
          link.className = 'link';
          link.textContent = url.hostname;
          link.target = '_blank';
          link.rel = 'noopener noreferrer';
          li.append(link);
          list.append(li);
        } catch {}
      }
    }
    if (Object.values(properties).some(value => typeof value === 'string' && value.trim())) {
      section.querySelector('[data-pen-carried]').hidden = false;
    }
    if (/^\d+$/.test(data.variantId)) back.searchParams.set('variant',data.variantId);
  }
  section.querySelector('[data-crc-pen-back]').href = back.href;
})();
